import Header from 'components/ui/Header';
import ReportList from 'components/reports/ReportList';
import withAuthorizer from 'components/ui/withAuthorizer';

import { Resources } from 'helpers/ResourceHelper';

import { useTranslation } from 'react-i18next';

const ReportsPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header>
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <h1 className="m-0 p-0 fw-lighter">{t('reports.title')}</h1>
          </div>
        </div>
      </Header>

      <div className="container mt-4">
        <ReportList />
      </div>
    </>
  );
};

export default withAuthorizer(ReportsPage, [Resources.REPORT_VIEW]);
